export {
  alignContentPositionProps,
  alignItemsPositionProps,
  alignSelfPositionProps,
  justifyContentPositionProps,
  justifyItemsPositionProps,
  justifySelfPositionProps,
  marginProperties,
  placeContentPositionProps,
  placeItemsPositionProps,
  placeSelfPositionProps,
  spacingProperties,
} from './sprinkle-properties.js';
export type {
  AlignContentPositionProps,
  AlignItemsPositionProps,
  AlignSelfPositionProps,
  JustifyContentPositionProps,
  JustifyItemsPositionProps,
  JustifySelfPositionProps,
  MarginProperties,
  PlaceContentPositionProps,
  PlaceItemsPositionProps,
  PlaceSelfPositionProps,
  SpacingProperties,
} from './sprinkle-properties.js';
